"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonLoaderWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var Declarative_1 = require("../../utils/Declarative");
var SkeletonLoaderInfoContext_1 = require("./SkeletonLoaderInfoContext");
var LoadingBone_1 = require("./LoadingBone");
Object.defineProperty(exports, "LoadingBone", { enumerable: true, get: function () { return LoadingBone_1.LoadingBone; } });
/**
 * A container for `<LoadingBone/>` components.
 * Used to orchestrate the shine animation across multiple `<LoadingBone/>`s.
 * By default, a SkeletonLoaderWidget will expand to 100% width. If you don't want this behavior, set `display: 'inline-block'` in your `style` prop.
 */
exports.SkeletonLoaderWidget = function (props) {
    var ariaLabel = props["aria-label"], ariaLabelledby = props["aria-labelledby"], children = props.children, darkMode = props.darkMode, fallback = props.fallback, isPending = props.isPending, testId = props.testId, restProps = tslib_1.__rest(props, ['aria-label', 'aria-labelledby', "children", "darkMode", "fallback", "isPending", "testId"]);
    var _a = React.useState(SkeletonLoaderInfoContext_1.EmptyRect), clientRect = _a[0], setClientRect = _a[1];
    var _b = React.useState(null), containerEl = _b[0], setContainerEl = _b[1];
    var resizeObserverRef = React.useRef();
    var startObserving = React.useCallback(function () {
        var _a;
        if (containerEl && !resizeObserverRef.current) {
            resizeObserverRef.current = new ResizeObserver(function () {
                setClientRect((containerEl === null || containerEl === void 0 ? void 0 : containerEl.getBoundingClientRect()) || SkeletonLoaderInfoContext_1.EmptyRect);
            });
        }
        if (containerEl) {
            (_a = resizeObserverRef.current) === null || _a === void 0 ? void 0 : _a.observe(containerEl);
        }
    }, [containerEl]);
    var stopObserving = React.useCallback(function () {
        if (containerEl && resizeObserverRef.current) {
            resizeObserverRef.current.unobserve(containerEl);
            resizeObserverRef.current = undefined;
        }
    }, [containerEl]);
    /** Starts and stops the resizeObserver depending on the state of `isPending` */
    React.useEffect(function () {
        if (containerEl && isPending) {
            startObserving();
        }
        return stopObserving;
    }, [containerEl, isPending, startObserving, stopObserving]);
    var skeletonLoaderInfoContextData = React.useMemo(function () { return ({
        clientRect: clientRect,
        darkMode: !!darkMode,
        isInitialized: true
    }); }, [clientRect, darkMode]);
    return (React.createElement(SkeletonLoaderInfoContext_1.SkeletonLoaderInfoContext.Provider, { value: skeletonLoaderInfoContextData },
        React.createElement("div", tslib_1.__assign({ ref: setContainerEl, role: !isPending ? undefined : 'img', "aria-label": !isPending ? undefined : (ariaLabel || (ariaLabelledby ? undefined : Localize_1.Messages.skeletonLoaderLabel())), "aria-labelledby": !isPending ? undefined : ariaLabelledby }, restProps, { "data-tb-test-id": Declarative_1.makeTestId(testId, 'SkeletonLoaderWidget') }), isPending ? fallback : children)));
};
exports.SkeletonLoaderWidget.displayName = 'SkeletonLoaderWidget';
//# sourceMappingURL=SkeletonLoaderWidget.js.map